// extracted by mini-css-extract-plugin
module.exports = {"header":"MonthHeader_header__2Ozd8","cell":"MonthHeader_cell__3hdzJ"};